import {
  ArrowRightIcon,
  FolderOpenIcon,
  MonitorSmartphone,
} from "lucide-react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { EntityInfoTooltip } from "@/components/EntityInfo";

const LinkedObject = styled(
  ({ className, object, href, variant = "text", ...props }: any) => {
    return (
      <EntityInfoTooltip
        type={object?.type}
        id={object?.id}
        side="bottom"
        align="start"
        delayDuration={600}
      >
        <Link
          to={href || ""}
          style={{ width: "fit-content" }}
          onContextMenu={(e) => e.stopPropagation()}
          className={`${className} linked-object ${variant}`}
          {...props}
        >
          {object?.id ? (
            <div className="text-container">
              {object.type === "case" ? (
                <FolderOpenIcon size={10} className={"folderIcon"} />
              ) : (
                <MonitorSmartphone size={10} className={"folderIcon"} />
              )}
              <div className="object-name">{object.name}</div>
              {href && <ArrowRightIcon size={12} className={"arrowIcon"} />}
            </div>
          ) : (
            <div>Unlinked</div>
          )}
        </Link>
      </EntityInfoTooltip>
    );
  }
)`
  max-width: 135px;
  text-transform: capitalize;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 0.65rem;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 3px;

  &.highlighted {
    color: ${({ theme }) => theme.palette.primary.main};
    background-color: ${({ theme }) => theme.palette.primary.main}25;
    padding: 2px 5px;
    border-radius: 5px;
  }

  .object-name {
    max-width: 125px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .text-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
  }

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .folderIcon {
    color: ${({ theme }) => theme.palette.primary.main};
  }

  .arrowIcon {
    display: none;
  }

  &:hover {
    text-decoration: underline;
    .arrowIcon {
      display: block;
    }
  }
`;

export default LinkedObject;
